<template>
  <div class="wx-invite-page">
    <div v-if="activityConfig" class="wx-invite-container">
      <img class="bg-image" :src="activityConfig.share_background" alt="" />
      <div class="invite-container">
        <div class="login-container">
          <div class="user-container">
            <img class="avatar" :src="avatar" alt="" />
            <div class="user-right">
              <div class="nickname">{{ nickname }}</div>
              <div class="desc">赠送您3日营养师指导服务</div>
            </div>
            <img
              class="icon-flag"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6c1fe510144122a611515d02bb5b16ce.png"
              alt=""
            />
          </div>

          <div
            class="qrcode-container"
            v-if="loaded && [2, 3].includes(inviteStatus)"
          >
            <div
              class="qrcode-text"
              v-html="activityConfig.share_description"
            ></div>
            <img
              class="qrcode-image"
              :src="activityConfig.share_content_qrcord"
              alt=""
            />
          </div>
          <div
            class="login-wrapper"
            v-if="loaded && [0, 1].includes(inviteStatus)"
          >
            <div class="input-item-content">
              <div class="input-item">
                <div class="item-text">手机号</div>
                <div class="item-input-container">
                  <input
                    v-model="phone"
                    class="item-input"
                    type="number"
                    placeholder="请输入手机号"
                  />
                </div>
              </div>
            </div>
            <div class="input-item-content">
              <div class="input-item">
                <div class="item-text">验证码</div>
                <div class="item-input-container">
                  <input
                    class="item-input"
                    type="number"
                    placeholder="请输入验证码"
                    maxlength="4"
                    v-model="code"
                  />
                </div>
              </div>
              <div class="code-btn" @click="handleSendCode">{{
                time ? time + '秒' : '获取验证码'
              }}</div>
            </div>
            <div class="agreement">
              <div class="toggle-agreement" @click="handleToggleAgreement"
                ><span class="iconfont icon-gou" v-show="agreement"></span
              ></div>
              <div
                >我已阅读并同意<span
                  class="agreement-bold"
                  @click="handleToAgreement"
                  >《用户协议》</span
                ></div
              >
            </div>
            <div class="register-btn" @click="handleRegister">接受邀请</div>
          </div>
        </div>
      </div>
      <div class="image-container">
        <div class="gift-list">
          <div class="gift-container">
            <img
              class="image-item"
              :src="activityConfig.friend_invited_prize_image"
              alt=""
            />
            <CourseContainer class="course-container" />
          </div>
        </div>
        <div class="case-container">
          <div class="c-title">在这里TA们都瘦了</div>
          <div class="c-title">56万+条真实用户评论</div>
          <div class="c-en">User Feedbacks</div>
          <div class="case-scroll">
            <div class="case-list">
              <img
                class="case-item"
                v-for="(item, index) in caseList"
                :key="index"
                :src="item"
              />
            </div>
          </div>
        </div>
        <div class="image-list">
          <img
            class="image-item"
            v-for="(item, index) in activityConfig.share_detail_images"
            :key="index"
            :src="item"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CourseContainer from './components/course-container.vue'
export default {
  components: { CourseContainer },
  data() {
    return {
      time: 0,
      phone: '',
      code: '',
      agreement: false,
      wxUserInfo: null,
      activityConfig: null,
      //邀请状态 1:用户没有接受过邀请  2:用户接受过邀请并再次进入非邀请人的邀请页面  3:用户接受过邀请并再次进入邀请人的邀请页面
      inviteStatus: 0,
      loaded: false,
      avatar: '',
      nickname: '',
      caseList: [
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6efa46a3d5880bc717f0ba497c644551.png',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/be2d079ae6f2a162dcf5d4726cfe6c40.png',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3304f3c2ee1a7a2d2e509706bd17a164.png',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/12e817f5c2e8ae1374b01f0ac080dbaa.png'
      ]
    }
  },
  created() {
    this.getParams()
    this.init()
  },
  methods: {
    getParams() {
      this.avatar = this.$route.query?.avatar
      this.nickname = this.$route.query?.nickname
    },
    canActivity() {
      if (!this.isStart) {
        this.$toast('活动未开始')
        return false
      } else if (this.isEnd) {
        this.$toast('活动已结束')
        return false
      }
      return true
    },
    handleSendCode() {
      if (!this.canActivity()) {
        return
      }
      if (this.time) {
        return
      }
      if (!this.agreement) {
        this.$toast('请先勾选用户协议')
        return
      }
      if (!this.phone) {
        this.$toast('电话号码不能为空')
        return
      }
      let params = {
        phone: this.phone,
        areaCode: '86'
      }
      this.$http.postBaseApp('sendSms', params).then((res) => {
        res = res.data
        if (res.code === 200) {
          this.$toast('发送成功')
          this.setCodeTime()
        } else {
          this.$toast(res.msg)
        }
      })
    },
    handleToggleAgreement() {
      this.agreement = !this.agreement
    },
    handleRegister() {
      if (!this.canActivity) {
        return
      }
      if (!this.agreement) {
        this.$toast('请先勾选用户协议')
        return
      }
      if (!this.phone) {
        this.$toast('电话号码不能为空')
        return
      }
      if (!this.code) {
        this.$toast('验证码不能为空')
        return
      }
      this.bindRegister()
    },
    setCodeTime() {
      this.time = 60
      this.timer = setInterval(() => {
        this.time--
        if (this.time <= 0) {
          clearInterval(this.timer)
        }
      }, 1000)
    },
    async bindRegister() {
      if (!this.wxUserInfo) {
        this.$toast('请完成微信授权')
        return
      }
      let params = {
        openid: this.wxUserInfo.openid,
        unionid: this.wxUserInfo.unionid,
        nickname: this.wxUserInfo.nickname,
        head_sculpture: this.wxUserInfo.headimgurl,
        phone: this.phone,
        msg_code: this.code,
        uid: this.$route.query.uid,
        areaCode: '86'
      }
      let res = await this.$http
        .postApp('api/v1/Introduction/register', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.inviteStatus = 3
          this.$toast('注册成功')
        } else {
          this.$toast(res.msg)
        }
      }
    },
    handleToAgreement() {
      this.$router.push('/agreement')
    },
    async getWxUserInfo() {
      let params = {
        sign_token: this.signToken
      }
      let res = await this.$http.getApp('getWxUserInfo', params).catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 1 && res.data) {
          this.wxUserInfo = res.data
          this.getIsInvited(res.data.openid)
        } else {
          this.$toast('请完成微信授权')
        }
      }
    },
    //获取是否被邀请过
    async getIsInvited(openid) {
      let params = {
        openid,
        unify_id: this.$route.query.uid
      }
      let res = await this.$http
        .getApp('api/v1/Introduction/inviteStatus', params)
        .catch(() => {})
      this.loaded = true
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.inviteStatus = res.data
          if (res.data == 2 && !this.isEnd) {
            this.$toast('你已经接受了其他人的邀请')
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    init() {
      this.signToken =
        this.$route.query.sign_token || localStorage.getItem('signToken') || ''
      if (this.$route.query.sign_token) {
        localStorage.setItem('signToken', this.$route.query.sign_token)
      }
      // 没有自带减脂营token则走减脂营授权拿token
      if (!this.signToken) {
        window.location.href = `https://btwx.gymcity.com.cn/wxAuth?auth=wegymer&scope=snsapi_userinfo&next=${encodeURIComponent(
          location.href
        )}`
      } else {
        this.getActivityConfig()
      }
    },
    async getActivityConfig() {
      let res = await this.$http
        .getApp('/api/v1/Introduction/config', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          res.data.share_detail_images = JSON.parse(
            res.data.share_detail_images
          )
          this.activityConfig = res.data
          this.isEnd =
            res.time * 1000 >=
              new Date(
                this.activityConfig.end_date.replace(/-/g, '/')
              ).getTime() || !this.activityConfig.state
          this.isStart =
            res.time * 1000 >=
            new Date(
              this.activityConfig.start_date.replace(/-/g, '/')
            ).getTime()
          this.canActivity()
          this.getWxUserInfo()
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wx-invite-page {
  background-color: #def0ff;
  min-height: 100vh;
  .wx-invite-container {
    overflow: hidden;
    position: relative;
    z-index: 0;
    .bg-image {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      z-index: -1;
    }
  }
  .invite-container {
    margin-top: 97px;
    margin-bottom: 15px;
    padding: 0px 16px;
    .login-container {
      box-shadow: 0px 3px 6px 0px rgba(12, 97, 192, 0.09);
      border-radius: 8px;
      overflow: hidden;
      .user-container {
        position: relative;
        background: #ffffff;
        padding: 35px 20px 20px;
        display: flex;
        align-items: center;
        .icon-flag {
          position: absolute;
          left: 50%;
          top: -2px;
          width: 172px;
          transform: translate(-50%, 0%);
        }
        .avatar {
          width: 36px;
          height: 36px;
          object-fit: cover;
          margin-right: 13px;
        }
        .user-right {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          .nickname {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: 13px;
            line-height: 22px;
            height: 22px;
          }
          .desc {
            font-weight: bold;
            font-size: 16px;
            color: #303038;
            line-height: 20px;
          }
        }
      }
      .login-wrapper {
        background-color: #fff;
        padding: 0px 20px 35px;
        .input-item-content {
          margin-bottom: 16px;
          display: flex;
          align-items: center;
        }
        .input-item {
          box-sizing: border-box;
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 37px;
          padding: 0px 16px;
          background: #f7f7f7;
          border-radius: 8px;
          border: 1px solid #f1f1f1;
          .item-text {
            white-space: nowrap;
            font-weight: bold;
            font-size: 14px;
            color: #303038;
            line-height: 20px;
          }
          .item-input-container {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
          }
          .item-input {
            width: 100%;
            border: none;
            outline: none;
            background: transparent;
            margin-left: 20px;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.3);
            line-height: 20px;
          }
        }
        .code-btn {
          text-align: center;
          width: 80px;
          height: 24px;
          font-weight: bold;
          font-size: 13px;
          color: #303038;
          line-height: 24px;
          margin-left: 10px;
        }
        .agreement {
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          font-size: 11px;
          line-height: 16px;
          .toggle-agreement {
            width: 14px;
            height: 14px;
            background: #f7f7f7;
            border-radius: 4px;
            border: 1px solid #cccccc;
            box-sizing: border-box;
            margin-right: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
              color: #ff2774;
              font-size: 12px;
              font-weight: bold;
            }
          }
          .agreement-bold {
            font-weight: bold;
            text-decoration: underline;
          }
        }
        .register-btn {
          height: 40px;
          line-height: 40px;
          background: linear-gradient(270deg, #ff2774 0%, #ff366d 100%);
          border-radius: 20px;
          text-align: center;
          font-weight: bold;
          font-size: 16px;
          color: #ffffff;
        }
      }
      .qrcode-container {
        background-color: rgba(255, 255, 255, 0.6);
        padding: 24px 0px 25px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .qrcode-text {
          font-size: 13px;
          color: #303038;
          line-height: 18px;
          text-align: center;
          margin-bottom: 11px;
        }
        .qrcode-image {
          width: 190px;
          height: 190px;
          object-fit: contain;
        }
      }
    }
  }
  .case-container {
    padding: 40px 0px;
    background: linear-gradient(180deg, #ffffff 0%, #fafafa 52%, #f5f5f5 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .c-title {
      font-family: MiSans, MiSans;
      font-weight: bold;
      font-size: 24px;
      line-height: 33px;
    }
    .c-en {
      font-family: MiSans, MiSans;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.7);
      line-height: 16px;
      margin-bottom: 24px;
    }
    .case-scroll {
      width: 100%;
      overflow-x: scroll;
      .case-list {
        display: inline-flex;
        align-items: center;
        padding: 0px 16px;
        .case-item {
          width: 289px;
          height: 369px;
          object-fit: contain;
          margin-right: 10px;
        }
        .case-item:last-child {
          margin-right: 0px;
        }
      }
    }
  }
  .gift-list {
    padding: 0px 12px;
    margin-bottom: 20px;
    .gift-container {
      position: relative;
    }
    .course-container {
      position: absolute;
      left: 0;
      width: 100%;
      top: 317px;
    }
  }
  .image-item {
    width: 100%;
  }
}
</style>
